import { ConnectBitget } from 'modules/auth/components/ConnectBitget';
import {
  ConnectDialog,
  ConnectDialogButtons,
  ConnectDialogTitle,
} from 'modules/auth/components/ConnectDialog';
import { ConnectOKX } from 'modules/auth/components/ConnectOKX';
import { ConnectTomo } from 'modules/auth/components/ConnectTomo';
import { ConnectXverse } from 'modules/auth/components/ConnectXverse';
import { useBtcConnectionModal } from 'modules/auth/hooks/useBtcConnectionModal';
import { useTranslation } from 'modules/i18n';
import { translation } from './translation';

export function BtcConnectionModal(): JSX.Element {
  const { isOpened, onClose } = useBtcConnectionModal();
  const { keys, t } = useTranslation(translation);

  return (
    <ConnectDialog open={isOpened} onClose={onClose}>
      <ConnectDialogTitle
        title={t(keys.title)}
        description={t(keys.description)}
      />

      <ConnectDialogButtons>
        <ConnectOKX />

        <ConnectXverse />

        <ConnectTomo />

        <ConnectBitget />
      </ConnectDialogButtons>
    </ConnectDialog>
  );
}
